
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external/homepage-sync",
      function () {
        return require("private-next-pages/external/homepage-sync/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external/homepage-sync"])
      });
    }
  